<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">LearnDoTeach</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">LearnDoTeach</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tablatihan" data-toggle="tab">#LearnDoTeach</a>                                                
											</li> 

											<!-- <li class="nav-item">
												<a class="nav-link" href="#tabkategori" data-toggle="tab">Kategori</a>                                                
											</li> 
                                             
											<li class="nav-item">
												<a class="nav-link" href="#tabsubject" data-toggle="tab"><span class="med-records">Subject</span></a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tablatihan" class="tab-pane fade show active">
                                            <div class="card card-table">
												<div class="card-body p-3">
                                                    <div class="row text-center">
                                                        <div class="col-md-6">
                                                            <div class="form-group card-label">
                                                                <!-- <label>Paket Bimbel</label> -->
                                                                <v-select
                                                                :options="lstpaket"
                                                                :reduce="lstpaket => lstpaket.id_sales" 
                                                                label="nama_paket"
                                                                v-model="id_paket_sales"
                                                                placeholder="Silahkan pilih Paket"
                                                                required
                                                                />
                                                                
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 ">
                                                            <button class="btn btn-primary btn-sm float-left" @click.prevent="getAll()"> Lihat Tugas </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

											<div class="card card-table mb-0">
												<div class="card-body">
                                                   
                                                    <div class="row mobile_row">
                                                        <div class="col-md-6"  v-for="(ref, index) in lsttryout" :key="ref">
                                                            <!-- {{randomLabel(index)}} -->
                                                            <div class="kt-widget2  box-shadow" >
                                                                <div class="kt-widget2__item " :class="['kt-widget2__item--'+labelBox[(index%4)+1]]" >
                                                                    <div class="kt-widget2__info">
                                                                        <div class="kt-widget2__checkbox">
                                                                        </div>
                                                                        <a class="kt-widget2__title">
                                                                            {{ref.judul_pertemuan}}
                                                                        </a>
                                                                        <a class="kt-widget2__username">
                                                                            Jumlah Soal : <span> {{ref.jumlah_soal}} </span>
                                                                        </a>
                                                                        <a class="kt-widget2__username">
                                                                            Status : 
                                                                            <!-- <span class="text-info">{{ref.jadwal_pertemuan_date}} - {{ref.jadwal_pertemuan_time}}</span> -->
                                                                            <span v-if="ref.fg_publish=='1'" class="text-info">Submited</span>
                                                                            <span v-if="ref.fg_publish=='0'" class="text-warning">Draft</span>
                                                                        </a>
                                                                    </div>
                                                                    <a href="#" class="btn btn-sm btn-bold btn-clean" data-toggle="dropdown" aria-expanded="false">
                                                                        <i class="fa fa-ellipsis-h"></i>
                                                                    </a>
                                                                    
                                                                    <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right" x-placement="bottom-end" style="position: absolute; transform: translate3d(180px, 40px, 0px); top: 0px; left: 0px; will-change: transform;">
                                                                        <ul class="kt-nav">
                                                                            
                                                                            <li class="kt-nav__item" v-if="ref.fg_publish=='0'">
                                                                                <a @click="getDetail(ref)" class="kt-nav__link">
                                                                                    <i class="kt-nav__link-icon fas fa-edit text-sm"></i> 
                                                                                    <span class="kt-nav__link-text text-xs">Buat Soal</span>
                                                                                </a>
                                                                            </li>
                                                                            <li class="kt-nav__item" v-if="ref.jumlah_soal >0">
                                                                                <a @click="getPreview(ref)" class="kt-nav__link">
                                                                                    <i class="kt-nav__link-icon fas fa-eye text-sm"></i> 
                                                                                    <span class="kt-nav__link-text text-xs">Preview Soal</span>
                                                                                </a>
                                                                            </li>
                                                                            <li class="kt-nav__item" v-if="ref.fg_publish=='1'  && ref.jumlah_soal >0">
                                                                                <a @click="goUnSubmit(ref)" class="kt-nav__link">
                                                                                    <i class="kt-nav__link-icon fas fa-upload text-sm"></i> 
                                                                                    <span class="kt-nav__link-text text-xs">Batalkan Submit</span>
                                                                                </a>
                                                                            </li>
                                                                            <li class="kt-nav__item" v-if="ref.fg_publish=='0'  && ref.jumlah_soal >0">
                                                                                <a @click="goSubmit(ref)" class="kt-nav__link">
                                                                                    <i class="kt-nav__link-icon fas fa-upload text-sm"></i> 
                                                                                    <span class="kt-nav__link-text text-xs">Submit</span>
                                                                                </a>
                                                                            </li>
                                                                            <li class="kt-nav__item" v-if="ref.fg_publish=='0' && ref.jumlah_soal >0">
                                                                                <a @click="getDelete(ref)" class="kt-nav__link">
                                                                                    <i class="kt-nav__link-icon fas fa-times text-sm"></i> 
                                                                                    <span class="kt-nav__link-text text-xs">Reset Soal</span>
                                                                                </a>
                                                                            </li>
                                                                            
                                                                        </ul>
                                                                    </div>

                                                                    <!-- <div class="dropdown dropdown-inline">
                                                                        <button type="button" class="btn btn-clean btn-sm btn-icon-md btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i class="flaticon-more-1"></i>
                                                                        </button>
                                                                        <div class="dropdown-menu dropdown-menu-right">
                                                                            <ul class="kt-nav">
                                                                                <li class="kt-nav__item">
                                                                                    <a href="#" class="kt-nav__link">
                                                                                        <i class="kt-nav__link-icon flaticon2-line-chart"></i>
                                                                                        <span class="kt-nav__link-text">Reports</span>
                                                                                    </a>
                                                                                </li>
                                                                                <li class="kt-nav__item">
                                                                                    <a href="#" class="kt-nav__link">
                                                                                        <i class="kt-nav__link-icon flaticon2-send"></i>
                                                                                        <span class="kt-nav__link-text">Messages</span>
                                                                                    </a>
                                                                                </li>
                                                                                <li class="kt-nav__item">
                                                                                    <a href="#" class="kt-nav__link">
                                                                                        <i class="kt-nav__link-icon flaticon2-pie-chart-1"></i>
                                                                                        <span class="kt-nav__link-text">Charts</span>
                                                                                    </a>
                                                                                </li>
                                                                                <li class="kt-nav__item">
                                                                                    <a href="#" class="kt-nav__link">
                                                                                        <i class="kt-nav__link-icon flaticon2-avatar"></i>
                                                                                        <span class="kt-nav__link-text">Members</span>
                                                                                    </a>
                                                                                </li>
                                                                                <li class="kt-nav__item">
                                                                                    <a href="#" class="kt-nav__link">
                                                                                        <i class="kt-nav__link-icon flaticon2-settings"></i>
                                                                                        <span class="kt-nav__link-text">Settings</span>
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div> -->
                                                                    
                                                                    
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
													<div class="table-responsive notmobile_menu">
                                                        <table id="tblLatihan" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <!-- <th class="text-left">Paket Bimbel</th> -->
                                                                    <th class="text-left">Materi Pertemuan</th>
                                                                    <th class="text-left">Jumlah Soal</th>
                                                                    <th class="text-left">Status</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                
                                                                <tr v-for="(ref, index) in lsttryout" :key="ref.id_to">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <!-- <td>{{ ref.nama_paket }}</td> -->
                                                                    <td>{{ ref.judul_pertemuan }}</td>
                                                                    <td class="text-center">{{ ref.jumlah_soal }}</td>
                                                                    <td>
                                                                        <span v-if="ref.fg_publish=='1'">Submited</span>
                                                                        <span v-if="ref.fg_publish=='0'">Draft</span>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn v-if="ref.fg_publish=='0'" class="btn btn-sm bg-info-light" depressed small @click="getDetail(ref)">
                                                                            <i class="fas fa-edit"></i> Buat Soal
                                                                        </v-btn>
                                                                        <v-btn v-if="ref.jumlah_soal >0" class="btn btn-sm bg-warning-light" depressed small @click="getPreview(ref)">
                                                                            <i class="fas fa-eye"></i> Preview Soal
                                                                        </v-btn>
                                                                        <v-btn v-if="ref.fg_publish=='1'  && ref.jumlah_soal >0" class="btn btn-sm bg-primary-light" depressed small @click="goUnSubmit(ref)">
                                                                            <i class="fas fa-download"></i> Batalkan Submit
                                                                        </v-btn>
                                                                        <v-btn v-if="ref.fg_publish=='0'  && ref.jumlah_soal >0" class="btn btn-sm bg-success-light" depressed small @click="goSubmit(ref)">
                                                                            <i class="fas fa-upload"></i> Submit
                                                                        </v-btn>
                                                                        <v-btn v-if="ref.fg_publish=='0' && ref.jumlah_soal >0" color="btn btn-sm bg-danger-light" depressed small @click="getDelete(ref)">
                                                                            <i class="fas fa-times"></i> Reset Soal
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Materi Tab -->
									
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <div id="previewMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Preview Soal {{ldt.nama_paket}} > {{ldt.judul_pertemuan}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                       <div class="row">
                            <div class="col-md-12" v-for="(ref, index) in lstsoal" :key="ref.soal.id_soal">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="login-header">
                                            <h3>Soal Nomor {{index+1}}
                                                <button v-if="ref.soal.ket_laporan" class="btn btn-rounded float-right" :class="{'btn-outline-danger': !ref.soal.ket_laporan, 'btn-outline-warning': ref.soal.ket_laporan}" @click="getLaporan()"><i class="fa fa-info-circle"></i> {{ref.soal.ket_laporan ? "Lihat laporan soal":""}} </button>
                                            </h3>
                                        </div>
                                    </div>
                                    <!-- Checkout Form -->
                                    <div class="card-body">
                                
                                        <!-- Personal Information -->
                                        <div class="info-widget">

                                            <div class="row">
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="titleContainer title " v-html="ref.soal.uraian_soal"></div>

                                                    <!-- quizOptions -->
                                                    <div class="optionContainer">
                                                    <!-- <tr v-for="(opsi,i) in this.list_jawaban" :key="opsi.id_jawaban"> -->

                                                        <div class="option" v-for="(response, idx) in ref.list_jawaban" :key="idx"
                                                       
                                                        :class="{ 'bg-info-light': (response.poin >0)}">
                                                            {{ response.jawaban }}. {{ response.uraian_jawaban }}
                                                            <button class="float-right">
                                                                <span >Poin Jawaban : {{response.poin}}</span> &nbsp;
                                                                <i class="fa" 
                                                                :class="{'fa-check':response.poin > 0}"
                                                                ></i> </button>
                                                            
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            
                                        </div>

                                        <div>
                                            <div class="login-header">
                                                    <h3>Pembahasan</h3>
                                            </div>
                                            <div class="alert alert-warning " v-html="ref.soal.pembahasan"></div>

                                            <!-- <button class="btn btn-rounded btn-outline-primary" @click.prevent="selectOption(-1)">Kosongkan Jawaban</button> -->
                                        </div>
                                    </div>
                                    <!-- /Checkout Form -->
                                </div>
                                
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>

       <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Reset Soal</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus semua soal yang telah dibuat di materi pertemuan <b>{{ ldt.judul_pertemuan }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'Materi',
    data() {
        return {
            lstpaket: [],
            id_paket_sales: "",
            lsttryout: [],
            // lstsubject: [],
            // lsthasil:[],
            lstsoal:[],            
            ldt: {
                id_paket_sales: '',
                id_paket_jadwal: '',
                nama_paket: '',
                judul_pertemuan: ''
            },
            labelBox: [
                "brand", "warning","danger","success","primary"
            ],
            // lstmateri: [],
            // lstsubmateri: [],
            // lsttingkatan: [],
            // lststspublish: [
            //     {id: '1', text: 'Aktif'},
            //     {id: '0', text: 'Tidak Aktif'}
            // ]
        }
    },
    created: function () {
        this.getAllPaket();
        // this.getAll();
        // this.getAllTingkatan();
        // this.getAllMateri();
        // this.getAllSubMateri();
    },  
    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },


        //--------------------------
        // Get Materi Pertemuan
        getAllPaket: function () {
            axios.get('api/paketsaya/'+localStorage.getItem('idUser'))
                .then(res => {
                    this.initDt("tblLatihan");
                    this.clearTbl("tblLatihan");
                    this.lstpaket = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get Materi Pertemuan
        getAll: function () {

            axios.get('api/ldt/'+localStorage.getItem('idUser')+'/'+this.id_paket_sales)
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblLatihan");
                    this.lsttryout = res.data.data;
                    this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New Materi
        goSubmit: function (ref) {
            axios.post('api/ldtsubmit', {
                    id_paket_sales: ref.id_paket_sales,
                    id_paket_jadwal: ref.id_paket_jadwal
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    // this.resetVar();
                    // $("#addMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Create New Materi
        goUnSubmit: function (ref) {
            axios.post('api/ldtunsubmit', {
                    id_paket_sales: ref.id_paket_sales,
                    id_paket_jadwal: ref.id_paket_jadwal
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    // this.resetVar();
                    // $("#addMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        getPreview: function (ref) {
            this.ldt = ref;
            axios.get('api/ldtpreviewsoal/'+localStorage.getItem("idUser")+'/'+ref.id_paket_sales+'/'+ref.id_paket_jadwal) //+this.$route.params.id)
                .then(res => {
                    $("#previewMdl").modal('show');

                    this.lstsoal = res.data.data;
                    // if(this.lstsoal){
                    //     this.setRowSoal(0);
                    // }
                    // console.log(this.lstsoal[0].soal.pembahasan);
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        filterKategori: function(value){
            this.tryout.id_materi = '';
            this.lstmateri = value? this.lstmateriori.filter(c => c.id_tingkatan == value) : this.lstmateriori;
        },
        
        filterSubject: function(value){
            this.tryout.id_sub_materi = '';
            this.lstsubject = value? this.lstsubmateri.filter(c => c.id_materi == value) : this.lstsubmateri;
        },


        // resetVar: function(ref,isDasabled=false){
        //     if(ref){                
        //         this.tryout.id_to = ref.id_to;
        //         this.tryout.nama_to = ref.nama_to;
        //         this.tryout.id_tingkatan = ref.id_tingkatan;
        //         this.tryout.id_materi = ref.id_materi;
        //         this.tryout.id_sub_materi = ref.id_sub_materi;
        //         this.tryout.waktu = ref.waktu;
        //         this.tryout.fg_publish = ref.fg_publish;
        //     } else {
        //         this.tryout.id_to = '';
        //         this.tryout.nama_to = '';
        //         this.tryout.id_tingkatan = '';
        //         this.tryout.id_materi = '';
        //         this.tryout.id_sub_materi = '';
        //         this.tryout.waktu = '';
        //         this.tryout.fg_publish = '';
        //     }
            
        //     $("#frm input").prop("disabled", isDasabled);
        //     $("#frm v-select").prop("disabled", isDasabled);
        // },

        // Get Detail and Show data to Modal
        getDetail: function (ref) {
            // nrouter.push("instructor/tryout/soal/"+ref.id_to);
            
            localStorage.setItem("id_paket_sales", ref.id_paket_sales); 
            localStorage.setItem("id_paket_jadwal", ref.id_paket_jadwal); 
            this.$router.push({name:'siswa-learndoteach-soal'}); //, params: {id_paket_sales: ref.id_sales, id_paket_jadwal: ref.id_paket_jadwal}}); 
            // this.resetVar(ref, true);
            // $("#addMdl").modal('show');
        },

        // Get Detail and Show data to Modal
        getTryout: function (ref) {
            this.tryout = ref;
            $("#kerjakanMdl").modal('show');            
            // this.$router.push({name:'admin-tryout-try', params: {id: ref.id_to}}); 
            // this.resetVar(ref, true);
            // $("#addMdl").modal('show');
        },

        doTryout: function () {
            // this.tryout = ref;
            $("#kerjakanMdl").modal('hide');   
            localStorage.setItem("id_to", this.tryout.id_to);      
            localStorage.setItem("time", this.tryout.waktu*60);   
            const lstsoal = localStorage.getItem('lstsoal');
            if(lstsoal){
                localStorage.removeItem('lstsoal');
            }
            
            this.$router.push({name:'admin-tryout-try'});//, params: {id: this.tryout.id_to}}); 
            // this.resetVar(ref, true);
            // $("#addMdl").modal('show');
        },

        getPembahasan: function (ref) {
            $("#hasilMdl").modal('hide');   
            localStorage.setItem("id_to", ref.id_to);      
            localStorage.setItem("id_user_to", ref.id_user_to);   
            
            this.$router.push({name:'admin-tryout-pembahasan'});
        },
 
        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            this.resetVar(ref);
            $("#addMdl").modal('show');
        },

        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.ldt = ref;
            $("#delMdl").modal('show');
        },
 
        // Delete Materi
        hapus: function () {
            axios.post('api/ldtdelall', {
                    id_paket_sales: this.ldt.id_paket_sales,
                    id_paket_jadwal: this.ldt.id_paket_jadwal,
                    id_user: localStorage.getItem('idUser')
                })
                .then(res => {
                    // handle success
                    
                    this.getAll();
                    $("#delMdl").modal('hide');
                    
                    let timerInterval
                    swal.fire({
                    title: 'Reset Soal',
                    html: 'Soal berhasil direset!',
                    timer: 2000,
                    // icon: 'success',
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === swal.DismissReason.timer) {
                        console.log('I was closed by the timer')
                    }
                    })
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        //--------------------------
        // Get Tingkatan
        getAllTingkatan: function () {
            axios.get('api/reftingkatan')
                .then(res => {
                    // console.log(res.data);
                    this.lsttingkatan = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get Materi
        getAllMateri: function () {
            axios.get('api/materi')
                .then(res => {
                    // console.log(res.data);
                    this.lstmateri = res.data.data;
                    this.lstmateriori = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get sub_materi
        getAllSubMateri: function () {
            axios.get('api/submateri')
                .then(res => {
                    // console.log(res.data);
                    this.lstsubmateri = res.data.data;
                    this.lstsubject = this.lstsubmateri;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getHasilTryout: function (ref) {
            axios.get('api/tryoutres/'+ref.id_to)
                .then(res => {
                    // console.log(res.data);
                    $("#hasilMdl").modal('show');
                    this.lsthasil = res.data.data;
                    this.initDt("tblHasil");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Siswa/LearnDoTeach/index.vue